/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';

import './FileInformation.scss';

import { RelativeDate } from '../../../localization/LocalizedDate';
import { FileSize, FileTypeName } from '../../../localization/LocalizedFile';
import IconAttachment from '../../../components/icons/IconAttachment';
import { Flagged } from '../../components/attributes/Flagged';

const FileFileName = (props) => {
  const { file } = props;

  return file.getName();
};

const FileExtraInfo = (props) => {
  const { file, languageCode, className, attachments, showFileSize, showFileTypeName, showAttached } = props;

  return (
    <div className={classnames('cmp-fileinformation-extrainfo', className)}>
      <RelativeDate
        date={file.getObservedDate().date}
        precision={file.getObservedDate().precision}
        dateKind="medium"
        languageCode={languageCode}
      />
      {showFileSize && <FileSize fileSizeData={file.fileSizeData()} />}
      {showFileTypeName && <FileTypeName file={file}/>}
      {(showAttached && Object.keys(attachments).length > 0) && <IconAttachment.Small color="gsLightest" />}
    </div>
  );
};

const FileSummaryFileViewWithIntl = (props) => {
  const { intl, file, attachments } = props;

  return (
    <div>
      <div className="font-body font-color-gsLightest" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
        <FileFileName file={file} />
        <Flagged isFlagged={file.data.flagged} />
      </div>
      <div className="font-caption-1 font-color-gsLightest">
        <FileExtraInfo
          file={file}
          attachments={attachments}
          languageCode={intl.locale}
          className=""
          showFileSize={true}
          showFileTypeName={false}
          showAttached={true}
        />
      </div>
    </div>
  );
};

export const FileSummaryFileView = injectIntl(FileSummaryFileViewWithIntl);
